// 总裁

let menuGeneralManager = [
    
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    // {
    //     path: '/p0',
    //     component: "HomeView",
    //     name: '营销管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p1',
    //     component: "HomeView",
    //     name: '运营管理',
    //     redirect:'/common/fileList',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"项目进度", 
    //             children:[
    //                 // {
    //                 //     pageAddress:"commonPage/projectManage/fileList",
    //                 //     path:"/common/fileList",
    //                 //     component:"fileList",
    //                 //     name:"项目资料管理"
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/projectManage/fileDetail",
    //                     path:"/common/fileDetail",
    //                     component:"fileDetail",
    //                     hidden:true,
    //                     name:"项目资料详情"
    //                 },
    //             ]
    //         }
    //     ]
    // },
    // {
    //     path: '/p2',
    //     component: "HomeView",
    //     name: '合同管理',
    //     redirect:'/common/CMcontractData',
    //     parent:true,
    //     children:[
    //         {
    //             parent:true,
    //             component:"Navigation",
    //             path:"/home",
    //             name:"合同管理",
    //             children:[
    //                 // {
    //                 //     pageAddress:"cm/CMcontractData",
    //                 //     path:"/common/CMcontractData",
    //                 //     component:"contractData",
    //                 //     name:"合同总纲",
    //                 //     meta:{
    //                 //         keepAlive:true,
    //                 //     }
    //                 // },
    //                 {
    //                     pageAddress:"commonPage/dataReport/contractDataInfo",
    //                     path:"/common/contractDataInfo",
    //                     component:"contractDataInfo",
    //                     hidden:true,
    //                     name:"合同总纲详情",
    //                 },
    //                 // {
    //                 //     pageAddress:"cm/CMProjectModifyList",
    //                 //     path:"/cm/project/CMProjectModifyList",
    //                 //     component:"CMProjectModifyList",
    //                 //     name:"变更合同"
    //                 // },
    //                 {
    //                     pageAddress:"CommonContractModifyDetail",
    //                     path:"/common/contractModify/CommonContractModifyDetail",
    //                     hidden:true,
    //                     name:"变更合同详情"
    //                 },
	// 				{
	// 					pageAddress:"CommonContractReadView0",
	// 					path:"/cm/contract/read_view0",
	// 					hidden:true,
	// 					name:"合同详情"
	// 				},
    //                 // {
    //                 //     pageAddress:"cm/CMContractIndexView",
    //                 //     path:"/cm/project/contractIndex",
    //                 //     component:"CMContractIndexView",
    //                 //     name:"待审合同"
    //                 // },
                    
    //                 {
    //                     pageAddress:"CommonContractAuditView",
    //                     path:"/common/contract/CommonContractEditView",
    //                     hidden:true,
    //                     name:"审核合同"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractReadView",
    //                     path:"/common/contract/CommonContractReadView",
    //                     hidden:true,
    //                     name:"合同详情"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractModifyCheck",
    //                     path:"/common/contractModify/CommonContractModifyCheck",
    //                     hidden:true,
    //                     name:"变更合同审核"
    //                 },
    //                 {
    //                     pageAddress:"CommonContractModifyDetail",
    //                     path:"/common/contractModify/CommonContractModifyDetail",
    //                     hidden:true,
    //                     name:"变更合同详情"
    //                 },
    //             ]
    //         }
    //     ]
    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p4',
    //     component: "HomeView",
    //     name: '材料管理',
    //     disable:true,//无权限
    // },
    {
        path: '/p5',
        component: "HomeView",
        name: '财务管理',
        redirect:'/common/financeData',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"总表视图",
                children:[
                    // {
                    //     pageAddress:"commonPage/dataReport/financeData",
                    //     path:"/common/financeData",
                    //     component:"financeData",
                    //     name:"财务总表",
                    //     meta:{
                    //         keepAlive:true,
                    //     }
                    // },
                    {
                        pageAddress:"commonPage/dataReport/financeDataInfo",
                        path:"/common/financeDataInfo",
                        component:"financeDataInfo",
                        hidden:true,
                        name:"财务数据详情"
                    },
                ]
            }
        ]
    },
    // {
    //     path: '/p6',
    //     component: "HomeView",
    //     name: '项目总监管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
	{
		path:'/p8',
        redirect: '/general/change_password',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // { 
                    //     path: '/general/change_password', 
                    //     component: "ChangePasswordView", 
                    //     name: '修改密码' 
                    // },
                ]
            }
        ]

    },
    {
        pageAddress:"commonPage/dataReport/printSettleForm",
        path:"/common/printSettleForm",
        component:"printSettleForm",
        hidden:true,
        name:"打印结算表"
    },
    
];

export default menuGeneralManager;


// WEBPACK FOOTER //
// ./src/menu/menuGeneralManager.js